export const ESIGN_CARD_CLASS =
  "w-full max-w-[680px] rounded-[20px] border border-[#E6E8EE] bg-white overflow-hidden";

export const esignStyles = {
  page: "flex h-screen h-[100dvh] max-h-[100dvh] flex-col overflow-hidden bg-[#F4F6F8] font-inter text-[#0F172A]",
  body: "mx-auto flex min-h-0 w-full flex-1 flex-col items-center overflow-y-auto px-6 py-6 sm:px-8 sm:py-8 lg:px-14 lg:py-10",
  cardBody: "flex flex-col gap-6 p-5 sm:p-8",
  hero: "flex flex-col gap-2",
  eyebrow: "text-xs font-semibold tracking-[0.8px] text-primary",
  cardTitle: "text-[28px] font-bold leading-9 text-[#0F172A]",
  cardSubtitle: "text-[15px] leading-[22px] text-[#64748B]",
  summaryHeader:
    "grid grid-cols-1 gap-4 rounded-2xl border border-[#ECF2FF] bg-[#F5F8FF] p-4 sm:grid-cols-3 sm:gap-4",
  summaryHeaderLabel: "text-[11px] font-medium leading-[15px] text-[#64748B]",
  summaryHeaderValue: "mt-1 break-words text-[13px] font-bold leading-[18px] text-[#0F172A]",
  statusRow: "flex items-center gap-3",
  statusIconWrap: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
  statusTitle: "text-base font-bold text-[#0F172A]",
  statusDescription: "mt-1 text-sm leading-5 text-[#64748B]",
  stepsWrap: "flex flex-col gap-2",
  stepRow:
    "flex items-center gap-3 rounded-xl border border-[#E6E8EE] bg-white px-3.5 py-3",
  stepNumber:
    "flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-primary text-[11px] font-bold text-white",
  stepText: "text-[13px] leading-[18px] text-[#0F172A]",
  alert: "rounded-xl border px-3.5 py-3 text-[13px] leading-[18px] font-medium",
  alertError: "border-red-200 bg-red-50 text-red-700",
  alertSuccess: "border-[#BAE3C7] bg-[#F0FCF2] text-[#176638]",
  alertWarning: "border-[#FCE5B2] bg-[#FFF8E7] text-[#915412]",
  hintText: "text-sm leading-relaxed text-[#64748B]",
  actions: "flex flex-col gap-3 sm:flex-row",
  primaryBtn:
    "flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-5 py-3.5 text-sm font-semibold text-white shadow-[0_8px_16px_rgba(15,92,242,0.22)] transition hover:bg-[#0a5ae0] disabled:cursor-not-allowed disabled:opacity-60 sm:flex-1",
  secondaryBtn:
    "flex w-full items-center justify-center gap-2 rounded-xl border border-[#E6E8EE] bg-white px-5 py-3.5 text-sm font-semibold text-[#0F172A] transition hover:bg-[#F8FAFC] disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto",
  footerNote: "text-center text-xs text-[#64748B]",
};
